import { useState } from 'react';

import { cx } from '@libs/classnames';
import { IconButton } from '@ui/components/IconButton';
import { useMediaQuery } from '@providers/MediaQueryProvider';
import { BurgerIcon } from '@ui/icons/BurgerIcon';

import { UserSettingsProps } from '@features/user/hooks/useUserSettings';
import { UserSettingsMenuPopover } from '@features/user/ui/UserSettingsMenu/UserSettingsMenuPopover';

import styles from './UserSettingsMenu.module.css';

type Props = { className?: string; settings?: UserSettingsProps };

export function UserSettingsMenu({ className, settings }: Props) {
  const isMobile = useMediaQuery() === 'mobile';
  const [isPopoverOpen, setIsPopoverOpen] = useState<boolean>(false);

  return (
    <div className={cx(styles.userSettingsMenu, className)}>
      <IconButton
        preset={isMobile ? 'transparent' : 'hollow'}
        onClick={() => setIsPopoverOpen(true)}
      >
        <BurgerIcon />
      </IconButton>

      <UserSettingsMenuPopover
        className={styles.userSettingsMenuPopover}
        onClose={() => setIsPopoverOpen(false)}
        isOpen={isPopoverOpen}
        settings={settings}
      />
    </div>
  );
}
